import React from "react";
import classnames from "classnames";
import { FmDropdownInput, FmIcon, FmText } from "..";
import { useTheme } from "../../Hooks";
import useStyles from "./FmHeader.style";
import { useSelector } from "react-redux";
import { GeneralState } from "../../Redux";

interface FmSidebarProps {
    units: { key: string; value: string }[];
    selectedUnit: string;
    onUnitSelect: (key: string) => void;
    languages: { key: string; value: string }[];
    selectedLanguage: string;
    onLanguageChange: (key: string) => void;
    fullName?: string;
    onNameClick?: () => void;
    className?: string;
    isEditMode?: boolean;
}

const FmHeader = ({
    units,
    selectedUnit,
    onUnitSelect,
    languages,
    selectedLanguage,
    onLanguageChange,
    fullName,
    onNameClick,
    className,
    isEditMode,
}: FmSidebarProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const isRtl = useSelector(GeneralState.Selectors.selectIsRtl);
    const itemClass = isRtl ? classes.rtlItem : classes.item;
    return (
        <div
            className={
                isEditMode ? classnames(classes.headerContainer, className, classes.headerContainerEditMode) : classnames(classes.headerContainer, className)
            }
        >
            <FmDropdownInput
                options={units}
                className={itemClass}
                onOptionSelect={onUnitSelect}
                selectedOptionKey={selectedUnit}
                icon={<FmIcon url={theme.images.units} />}
            />
            <FmDropdownInput
                options={languages}
                className={itemClass}
                onOptionSelect={onLanguageChange}
                selectedOptionKey={selectedLanguage}
                icon={<FmIcon url={theme.images.earth} />}
            />
            <div className={classnames(classes.nameContainer, itemClass)} onClick={onNameClick}>
                <div className={classes.iconContainer}>
                    <FmIcon url={theme.images.user} />
                </div>
                <div className={classes.textContainer}>
                    <FmText>{fullName}</FmText>
                </div>
            </div>
        </div>
    );
};

export default FmHeader;
